import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-dark text-white" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "Nama Penerima"),
    /*#__PURE__*/_createElementVNode("th", null, "Nama Kasir"),
    /*#__PURE__*/_createElementVNode("th", null, "Nominal Uang Tips"),
    /*#__PURE__*/_createElementVNode("th", null, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", null, "Jam Lapor"),
    /*#__PURE__*/_createElementVNode("th", null, "Keterangan")
  ])
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "7" }, "Data tidak ada!")
], -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: "Detil Uang Tips",
    modalShow: _ctx.modalShow,
    modalSize: _ctx.modalSize,
    onOnHide: _ctx.onClick
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _hoisted_3,
          (!_ctx.isEmpty)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tips, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: 'tips' + index
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(item.m_karyawan_name), 1),
                    _createElementVNode("td", null, _toDisplayString(item.nama_kasir), 1),
                    _createElementVNode("td", null, _toDisplayString(item.amount_debit), 1),
                    _createElementVNode("td", null, _toDisplayString(item.tanggal), 1),
                    _createElementVNode("td", null, _toDisplayString(item.jam), 1),
                    _createElementVNode("td", null, _toDisplayString(item.keterangan), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.isEmpty)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "btn btn-accent",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
      }, "OK")
    ]),
    _: 1
  }, 8, ["modalShow", "modalSize", "onOnHide"]))
}